import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './RoomEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import { MainCatalogSelect } from '../MainCatalogEditorTools';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import AudienceSeatingLayoutEntry from './AudienceSeatingLayoutEntry/AudienceSeatingLayoutEntry';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

interface EvServiceEntry {
    serviceID: string;
    serviceColor: more.EntityAPIColor;
    assignmentID: string;
    description: string;
    isDeleted?: boolean;
    blobNode?: HTMLElement;
    blobIcon?: HTMLElement;
}
class RoomEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;


    rm_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    rm_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    rm_Input_TextColor: HTMLInputElement;
    rm_Input_BackgroundColor: HTMLInputElement;
    rm_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    rm_Input_RoomType: MdsLax<InstanceType<typeof SearchSelect>>;
    rm_Select_Venue: MdsLax<InstanceType<typeof MainCatalogSelect>>;

    rm_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    rm_Checkbox_WithPublic: MdsLax<InstanceType<typeof CheckBox>>;
    //rm_Checkbox_GetColorationFromGroup: CheckBox = new CheckBox();
    rm_Checkbox_NotRelevantForOverlappingBookings: MdsLax<InstanceType<typeof CheckBox>>;

    roomVenueEditorContainer: HTMLElement;

    audienceSeatingLayoutsContainer: HTMLElement;
    audienceSeatingButtonAdd: HTMLButtonElement;
    allAudienceSeatingEntries: Array<MdsLax<InstanceType<typeof AudienceSeatingLayoutEntry>>>;


    input_Services: MdsLax<InstanceType<typeof MultiselectBox>>;

    inputServicesContainer: HTMLElement;
    selectedServicesContainer: HTMLElement;

    selectedServices: Array<EvServiceEntry> = [];


    formData: MainCatalogTypes.EvRoom_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        order: null,
        coloration: null,
        venue_id: "",
        ev_room_type_id: "",
        note: "",
        is_with_public: null,
        //is_get_coloration_from_group: null,
        is_not_relevant_for_overlapping_bookings: null,
        evServices: [],
        audience_seating_layout_entries: []
    };
    originalData: string = "";

    prepareFormData(data?: MainCatalogTypes.EvRoom_LoadData): void {

        let roomTypeId: string = null;
        let venueId: string = null;
        this.selectedServices = [];
        let alreadySelectedServices: Array<string>;
        this.allAudienceSeatingEntries = new Array<MdsLax<InstanceType<typeof AudienceSeatingLayoutEntry>>>();
        this.UiModder.domConstruct.empty(this.audienceSeatingLayoutsContainer);

        if (data) {
            this.selectedServices = data.evServices;

            this.requestTabRename(data.description);

            this.rm_Input_Code.setValue(data.code, true);
            this.rm_Input_Description.setValue(data.description, true);

            this.rm_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.rm_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.rm_Input_Order.setValue(data.order, true);

            this.rm_Input_RoomType.loadListValues(data.ref_ev_room_type?.ID, true);
            roomTypeId = data.ref_ev_room_type?.ID;

            this.rm_Select_Venue.setCatalog(MainCatalogs_Classes.Venues,
                this.translations["General_Label_Venue"], true, data.ref_venue?.ID);

            venueId = data.ref_venue?.ID;

            alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
                return assignment.serviceID;
            });
            if (this.input_Services.entries) this.input_Services.setValue(alreadySelectedServices, true);

            this.rm_Input_Note.setValue(data.note, true);
            this.rm_Checkbox_WithPublic.setValue(data.is_with_public, true);
            //this.rm_Checkbox_GetColorationFromGroup.setValue(data.is_get_coloration_from_group, true);
            this.rm_Checkbox_NotRelevantForOverlappingBookings.setValue(data.is_not_relevant_for_overlapping_bookings, true);

            data.audience_seating_layouts.forEach(layout => {

                let entry = new AudienceSeatingLayoutEntry();
                entry.setEntry(false, layout);
                entry.placeAt(this.audienceSeatingLayoutsContainer);
                on(entry, "SerializeData", lang.hitch(this, this._onChangeInputDataGeneric));
                on(entry, "AudienceSeatingLayout_Destroy", lang.hitch(this, this._onDestroyAudienceSeatingLayout, entry));

                this.allAudienceSeatingEntries.push(entry);
            });

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.rm_Input_Code.setValue("", true);
            this.rm_Input_Description.setValue("", true);

            this.rm_Input_BackgroundColor.value = "#ffffff";
            this.rm_Input_TextColor.value = "#000000";

            this.rm_Input_Order.setValue(null, true);

            this.rm_Input_RoomType.loadListValues();

            this.rm_Select_Venue.setCatalog(MainCatalogs_Classes.Venues,
                this.translations["General_Label_Venue"], true);
            this.rm_Select_Venue.setValue(null);

            alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
                return assignment.serviceID;
            });
            if (this.input_Services.entries) this.input_Services.setValue(alreadySelectedServices, true);

            this.rm_Input_Note.setValue("", true);
            this.rm_Checkbox_WithPublic.setValue(true, true);
            //this.rm_Checkbox_GetColorationFromGroup.setValue(false, true);
            this.rm_Checkbox_NotRelevantForOverlappingBookings.setValue(false, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        //this.UiModder.domClass.remove(this.rm_Select_Venue.editForm.editFormLeftSection, "m6");
        //this.UiModder.domClass.replace(this.rm_Select_Venue.editForm.editFormRightSection, "w3-hide", "m6");

        this.serializeFormData(roomTypeId, venueId);
        this.formData.evServices.forEach((x: EvServiceEntry) => { x.isDeleted = false; });
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();

        this._onChangeInput_Services(alreadySelectedServices, { roomTypeId: roomTypeId, venueId: venueId });
    }

    serializeFormData(roomTypeId?: string, venueId?: string): void {

        this.formData.code = this.rm_Input_Code.getValue();
        this.formData.description = this.rm_Input_Description.getValue();

        this.requestTabRename(this.formData.description);

        this.formData.order = this.rm_Input_Order.getValue();

        roomTypeId ? this.formData.ev_room_type_id = roomTypeId : this.formData.ev_room_type_id = this.rm_Input_RoomType.getValue();
        venueId ? this.formData.venue_id = venueId : this.formData.venue_id = this.rm_Select_Venue.getValue();

        this.formData.evServices = this.selectedServices;

        this.formData.note = this.rm_Input_Note.getValue();
        this.formData.is_with_public = this.rm_Checkbox_WithPublic.getValue();
        //this.formData.is_get_coloration_from_group = this.rm_Checkbox_GetColorationFromGroup.getValue();
        this.formData.is_not_relevant_for_overlapping_bookings = this.rm_Checkbox_NotRelevantForOverlappingBookings.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.rm_Input_TextColor.value;
        let backHex = this.rm_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        this.formData.audience_seating_layout_entries = [];

        for (let i = 0; i < this.allAudienceSeatingEntries.length; i++) {
            let item = this.allAudienceSeatingEntries[i];
            this.formData.audience_seating_layout_entries.push(item.editor.formData);
        }
        /*
        this.allAudienceSeatingEntries.forEach(item => {
            this.formData.audience_seating_layout_entries.push(item.editor.formData);
        });*/

        console.debug("SERIALIZED DATA", this.formData);
    }


    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        return b;
    }

    private addServiceBlob(serviceAssignment: EvServiceEntry) {

        let blob = this.UiModder.domConstruct.create("div", {
            className: "flex_row_center round nowrap border w3-tooltip",
            order: 100
        }, this.selectedServicesContainer);

        let tooltip = this.UiModder.domConstruct.create("span", {
            style: "position:absolute;left:22px;bottom:16px; pointer-events:none;",
            class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
            innerHTML: serviceAssignment.description
        }, blob);

        let blobX = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base mds-hover-dark warningTXT round",
            innerHTML: "<i class='fas fa-times'></i>"
        }, blob);
        on(blobX, "click", lang.hitch(this, this._onClick_RemoveService, serviceAssignment));


        // gelöscht?
        this.UiModder.domClass.toggle(blob, "strike w3-disabled", serviceAssignment.isDeleted === true);

        let blobLabel = this.UiModder.domConstruct.create("div", {
            className: "paddingSmall",
            style: "max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;",
            innerHTML: serviceAssignment.description
        }, blob);

        let colorHexBG = "#ffffff";
        let colorHexTXT = "#000000";
        if (serviceAssignment.serviceColor) {
            colorHexBG = serviceAssignment.serviceColor.BackColor?.Hex;
            colorHexTXT = serviceAssignment.serviceColor.TextColor?.Hex;
        }

        if (colorHexBG) {
            this.UiModder.domStyle.set(blob, "backgroundColor", colorHexBG);
        }

        if (colorHexTXT) {
            this.UiModder.domStyle.set(blobLabel, "color", colorHexTXT);
        }
    }

    private drawSelectedCategoryBlobs(data?: MainCatalogTypes.ServicePackage_SaveData) {

        if (!data) {
            data = this.formData;
        }

        this.UiModder.domConstruct.empty(this.selectedServicesContainer);

        let servicesIds: Array<string> = [];

        if (data) {
            for (let assignedService of <Array<EvServiceEntry>>data.evServices) {
                // wir benötigen:
                // categoryIds (nicht assignment) für das Searchselect, damit die dort vorausgewählt sind
                // und wir erstellen die Blobs für schnellere Übersicht

                if (!assignedService.isDeleted) {
                    servicesIds.push(assignedService.serviceID);
                }

                this.addServiceBlob(assignedService);
            }
        }
    }

    private _onClick_RemoveService(targetAssignment: EvServiceEntry) {

        let selectedIDs: Array<string> = [];

        let deletedCategory = this.selectedServices.filter(x => x.serviceID === targetAssignment.serviceID)[0];

        deletedCategory.assignmentID ? deletedCategory.isDeleted = true : this.selectedServices.splice(this.selectedServices.indexOf(deletedCategory), 1);

        this.selectedServices.forEach(serviceAssignment => {

            if (serviceAssignment.isDeleted !== true) selectedIDs.push(serviceAssignment.serviceID);
        });

        this.input_Services.setValue(selectedIDs);
    }

    _onChangeInput_Services(newValues: Array<string>, origValues: { roomTypeId: string, venueId: string } = null /*servicePackGroupId?: string*/) {

        let entityValues = this.input_Services.getValue(true);
        let labelProp = this.input_Services.labelAttribute;
        let valueProp = this.input_Services.valueAttribute;
        console.log("_onChangeInput_Services", newValues, entityValues);

        let missingServices: Array<string> = [];
        let alreadySelectedServices: Array<string> = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
            return assignment.serviceID;
        });

        let newAssignmentArray: Array<EvServiceEntry> = [];

        this.selectedServices.forEach(serviceAssignment => {

            if (serviceAssignment.assignmentID) {

                serviceAssignment.isDeleted = newValues.indexOf(serviceAssignment.serviceID) == -1;
            }

            if ((newValues.length > 0 && newValues.indexOf(serviceAssignment.serviceID) > -1) || serviceAssignment.isDeleted !== undefined) {

                newAssignmentArray.push(serviceAssignment);
            }
        });

        for (let entity of entityValues) {
            if (alreadySelectedServices.indexOf(entity[valueProp]) == -1) { // bisher noch nicht zugeordnet - neuer Eintrag!
                newAssignmentArray.push({
                    assignmentID: null,
                    serviceID: entity[valueProp],
                    serviceColor: entity.coloration,
                    description: entity[labelProp],
                });
            }
        }

        //this.formData.categories = newAssignmentArray;
        this.selectedServices = newAssignmentArray;

        origValues === null ? this.serializeFormData() : this.serializeFormData(origValues.roomTypeId, origValues.venueId);
        this.checkDirty();

        this.drawSelectedCategoryBlobs();
    }

    _onClick_Button_audienceSeatingButtonAdd(): void {

        //alert("audienceSeatingButtonAdd - in Bearbeitung!");
        let entry = new AudienceSeatingLayoutEntry();
        entry.setEntry(true);
        entry.placeAt(this.audienceSeatingLayoutsContainer);
        on(entry, "SerializeData", lang.hitch(this, this._onChangeInputDataGeneric));
        on(entry, "AudienceSeatingLayout_Destroy", lang.hitch(this, this._onDestroyAudienceSeatingLayout, entry));

        this.UiModder.domClass.add(entry.domNode, "accentOutline round mds-bg-green w3-margin");

        this.allAudienceSeatingEntries.push(entry);

        this.serializeFormData();
        this.checkDirty();
    }

    _onDestroyAudienceSeatingLayout(entry: MdsLax<InstanceType<typeof AudienceSeatingLayoutEntry>>): void {
        let index = this.allAudienceSeatingEntries.indexOf(entry);

        this.allAudienceSeatingEntries.splice(index, 1);

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeRoomInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeRoomNoteInputData(): void {

        this.fixNewLineInMultilineEdit(this.rm_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    loadEvServicesMultiSelect(): void {

        let requestUrl = window.appRoot + "MainCatalogsEditor/GetEvServicesMultiSelectList";
        //this.StandbyStart();
        this.UiModder.domClass.add(this.inputServicesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");

        this.RequestManager.post(
            requestUrl,
            null,
            lang.hitch(this, this._onLoadEvServicesMultiSelectResult),
            lang.hitch(this, this._onLoadEvServicesMultiSelectError),
            false // sync
        );
    }

    _onLoadEvServicesMultiSelectResult(data: any): void {

        let preset: Array<string> = [];
        let alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
            return assignment.serviceID;
        });
        if (alreadySelectedServices.length > 0) preset = alreadySelectedServices;
        else preset = this.input_Services.getValue();

        this.input_Services.setData(preset, data, true);

        this.UiModder.domClass.remove(this.inputServicesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");
    }

    _onLoadEvServicesMultiSelectError(err: any): void {

        // TODO
        alert(err.Message);
    }

    closeVenueEdit(): void {

        this.rm_Select_Venue.editForm?.close();
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        on(this, "CatalogEntityData_Save", () => {
            this.input_Services.setValue(null, true);
        });
        this.loadEvServicesMultiSelect();

        this.entityClass = MainCatalogs_Classes.EvRoom;

        this.rm_Input_Code.setMaxLength(10);
        this.rm_Input_Description.setMaxLength(255);
        this.rm_Input_Note.setMaxLength(2000);
        this.rm_Input_Note.setValidationEnabled(false);

        this.rm_Input_RoomType.setOuterPlaceholder("MainCatalogsEditor_Placeholder_RoomType");

        this.rm_Select_Venue.placeAt(this.roomVenueEditorContainer);
        this.UiModder.domClass.add(this.rm_Select_Venue.domNode, "w3-margin-left w3-margin-right");
        on(this.rm_Select_Venue, "change", lang.hitch(this, this._onChangeRoomInputData));

        on(this, "MainCatalogSelect_ShowHideAddChange", lang.hitch(this, this.closeVenueEdit));
        on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeVenueEdit));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(RoomEditor.prototype, {
  rm_Input_Code: () => (new Edit()),
  rm_Input_Description: () => (new Edit()),
  rm_Input_Order: () => (new NumberInput()),
  rm_Input_RoomType: () => (new SearchSelect()),
  rm_Select_Venue: () => (new MainCatalogSelect()),
  rm_Input_Note: () => (new Edit()),
  rm_Checkbox_WithPublic: () => (new CheckBox()),
  rm_Checkbox_NotRelevantForOverlappingBookings: () => (new CheckBox()),
});
export default mdsWidget(RoomEditor);
